@if (therapistDashboard){
<div class="row mb-5">
    <div class="col-6 my-3">
        <div class="card dashboard__card p-4 h-100 d-flex justify-content-center">
            <h3 class="mb-0">{{therapistDashboard.queueLength}}</h3>
            <p class="mb-0">Total waiting</p>
        </div>
    </div>
    <div class="col-6 my-3">
        <div class="card dashboard__card p-4 h-100 d-flex justify-content-center" (click)="viewAnyQueue();">
            <h3 class="mb-0">{{therapistDashboard.totalWaitingForAnyone}}</h3>
            <p class="mb-0">Total waiting (for anyone)</p>
        </div>

    </div>
    <div class="col-6 my-3">
        <div class="card dashboard__card p-4 h-100 d-flex justify-content-center" (click)="viewMyQueue();">
            <h3 class="mb-0">{{therapistDashboard.totalWaitingForMe}}</h3>
            <p class="mb-0">Total waiting (for me)</p>
        </div>
    </div>
    <div class="col-6 my-3">
        <div class="card dashboard__card p-4 h-100 d-flex justify-content-center">
            <h3 class="mb-0">{{therapistDashboard.numberOfBookingsCompleted}}</h3>
            <p class="mb-0">Completed</p>
        </div>
    </div>
</div>
}

@if (therapistDashboard){
@if (newCurrentBooking && newCurrentBooking.bookingID > 0){

<h2 class="mb-3">CURRENT BOOKING</h2>

<!-- GENERAL TEMPLATE FOR BOOKINGS -->
<div class="row">
    <div class="col-12">
        <div class="card dashboard__card dashboard__card--booking p-4">
            <!-- GENERAL TEMPLATE FOR BOOKINGS -->

            <!-- BOOKING STATUS CONTENT -->


            @if (newCurrentBooking.bookingStatusID === 7){
            <!-- BOOKING CANCELLED BY CLIENT -->
            <div class="col-12 text-center">
                <span class="material-symbols-outlined status__icon">cancel</span>
                <h2 mat-dialog-title>MASSAGE CANCELLED BY CLIENT</h2>
                <div class="row g-3 w-100">
                    <div class="col-12">
                        <button (click)="getNextBooking()"
                            [disabled]="gettingNextBooking || ((therapistDashboard.totalWaitingForAnyone === 0 && therapistDashboard.totalWaitingForMe === 0) || therapistDetail.therapistStatusID === 4)"
                            class="w-100" mat-flat-button color="primary">
                            @if (therapistDashboard.totalWaitingForAnyone === 0 && therapistDashboard.totalWaitingForMe
                            === 0){
                            NO BOOKINGS AVAILABLE
                            }@else{
                            GET NEXT BOOKING
                            }
                        </button>
                        <button (click)="quickCreateNewBooking();" mat-button class="w-100 mt-3" color="accent">
ADD NEW BOOKING                        </button>
                    </div>
                </div>
            </div>
            }

            @else if (newCurrentBooking.bookingStatusID === 3){
            <!-- BOOKING ASSIGNED TO THERAPIST -->
            <div class="col-12 text-center">
                <span class="material-symbols-outlined status__icon">check_circle</span>
                <h2 mat-dialog-title>ACCEPT YOUR MASSAGE</h2>
                <p style="font-weight: bold;">{{newCurrentBooking.fullName}}</p>
                <p>Client has been waiting for {{waitTimeLength|number:'1.0-0'}} minutes</p>
                @if (newCurrentBooking.requestedTherapistID){
                                <p>Requested therapist: {{newCurrentBooking.therapistName}}</p>
                }
                <p>Table: {{newCurrentBooking.location}}</p>
                <p>Location: {{newCurrentBooking.otherNotes}}</p>

                @if(newCustomerDataChanged){
                <div class="alert moved-alert">Please note the customer has updated their details and may have moved
                </div>
                }

                <div class="row g-3">
                    <div class="col-12">
                        <button [disabled]="changeBookingStatusClicked" (click)="acceptBookingNew(newCurrentBooking.bookingID)" class="w-100" mat-flat-button
                            color="primary">
                            ACCEPT BOOKING
                        </button>
                    </div>
                    <div class="col-12">
                        <button [disabled]="changeBookingStatusClicked" (click)="declineBookingNew(newCurrentBooking.bookingID)" class="w-100" mat-button
                            color="warn">
                            DECLINE BOOKING
                        </button>
                    </div>
                </div>
            </div>
            }
            @else if (newCurrentBooking.bookingStatusID === 4){
            <!-- BOOKING ACCEPTED BY THERAPIST -->
            <div class="col-12 text-center">
                <span class="material-symbols-outlined status__icon">massage</span>
                <h2 mat-dialog-title>START YOUR MASSAGE</h2>
                <p style="font-weight: bold;">{{newCurrentBooking.fullName}}</p>
                <p>Client has been waiting for {{waitTimeLength|number:'1.0-0'}} minutes</p>
                @if (newCurrentBooking.requestedTherapistID){
                <p>Requested therapist: {{newCurrentBooking.therapistName}}</p>
                }
                <p>Table: {{newCurrentBooking.location}}</p>
                <p>Location: {{newCurrentBooking.otherNotes}}</p>
                <div class="row g-3">
                    <div class="col-12">
                        <button mat-flat-button class="w-100" color="primary" [disabled]="changeBookingStatusClicked"
                            (click)="startMassageNew(newCurrentBooking.bookingID);" cdkFocusInitial>START
                            MASSAGE</button>
                    </div>
                    <div class="col-12">
                        <button [disabled]="changeBookingStatusClicked" mat-button class="w-100" color="warn"
                            (click)="massageCancelledNew(newCurrentBooking.bookingID);" cdkFocusInitial>MASSAGE DIDN'T
                            HAPPEN</button>
                    </div>

                </div>
            </div>
            }
            @else if (newCurrentBooking.bookingStatusID === 5){
            <!-- BOOKING IN PROGRESS -->
            <div class="col-12 text-center">
                <span class="material-symbols-outlined status__icon">massage</span>
                <h2 mat-dialog-title>MASSAGE IN PROGRESS</h2>
                <h3>{{newCurrentBooking.fullName}}</h3>
                <p>Massage length: {{newMassageLength | number: '1.0-0'}} minutes</p>
                <div class="row g-3">
                    <div class="col-12">
                        <button mat-flat-button class="w-100" color="primary" [disabled]="changeBookingStatusClicked"
                            (click)="endMassageNew(newCurrentBooking.bookingID);" cdkFocusInitial>END MASSAGE</button>
                    </div>
                    <div class="col-12">
                        <button mat-button class="w-100" color="warn" [disabled]="changeBookingStatusClicked"
                            (click)="endMassageWithBreakNew(newCurrentBooking.bookingID);" cdkFocusInitial>END WITH
                            BREAK</button>
                    </div>

                </div>
            </div>
            }
            @else if (newCurrentBooking.bookingStatusID === 6 && newCurrentBooking.treatmentEnd){
            <!-- BOOKING COMPLETED -->
            <div class="col-12 text-center">
                <span class="material-symbols-outlined status__icon">check_circle</span>
                <h2 mat-dialog-title>MASSAGE COMPLETE</h2>

                <p style="font-weight: bold;">{{newCurrentBooking.fullName}}</p>
                <p>Massage ran for: {{getMassageLength()}} minutes</p>
                <div class="row g-3">
                    <div class="col-12">
                        <button (click)="getNextBooking()"
                            [disabled]="gettingNextBooking || ((therapistDashboard.totalWaitingForAnyone === 0 && therapistDashboard.totalWaitingForMe === 0) || therapistDetail.therapistStatusID === 4)"
                            class="w-100" mat-flat-button color="primary">
                            @if (therapistDashboard.totalWaitingForAnyone === 0 && therapistDashboard.totalWaitingForMe
                            === 0){
                            NO BOOKINGS AVAILABLE
                            }@else{
                            GET NEXT BOOKING
                            }
                        </button>
                        <button (click)="quickCreateNewBooking();" mat-button class="w-100 mt-3" color="accent">
                            ADD NEW BOOKING
                        </button>
                    </div>

                </div>
            </div>
            }

            <!-- ENDS BOOKING STATUS CONTENT -->

            <!-- GENERAL TEMPLATE FOR BOOKINGS -->
        </div>
    </div>
</div>
<!-- GENERAL TEMPLATE FOR BOOKINGS -->


}
@else{
<!-- NO CURRENT BOOKING! -->
<button (click)="getNextBooking()"
    [disabled]="gettingNextBooking || ((therapistDashboard.totalWaitingForAnyone === 0 && therapistDashboard.totalWaitingForMe === 0) || therapistDetail.therapistStatusID === 4)"
    class="w-100" mat-flat-button color="primary">
    @if (therapistDashboard.totalWaitingForAnyone === 0 && therapistDashboard.totalWaitingForMe === 0){
    NO BOOKINGS AVAILABLE
    }@else{
    GET NEXT BOOKING
    }
</button>

<button (click)="quickCreateNewBooking();" mat-button class="w-100 mt-3" color="accent">
ADD NEW BOOKING</button>

}
}